import {
  Avatar, AvatarProps, ICON_STAR_OUTLINE,
} from '@doveit/bricks';
import React from 'react';

export type ReviewAvatarProps = Omit<AvatarProps, 'color' | 'icon'>;

export const ReviewAvatar: React.FC<ReviewAvatarProps> = (props) => (
  <Avatar
    {...props}
    placeholder={ICON_STAR_OUTLINE}
  />
);

export default ReviewAvatar;
